import apkSrc from "../assets/download/g1cash-1.0.1.apk";

const APP_TYPE = {
    // googlestore: "https://play.google.com/store/apps",
    // appstore: "https://apps.apple.com/apps",
    googlestore: "https://play.google.com/store/apps/details?id=com.hustem.g1cash&pli=1",
    appstore: "https://apps.apple.com/us/app/g1cash/id6459447318",
};

export const downloadApk = () => {
    window.open(
        process.env.PUBLIC_URL + "/apk/g1cash.apk"
      )
};
export const alertComming = () => {
    window.alert("COMMING SOOON!");
};
export const onClickAppDownLink = (type) => {
    window.open(APP_TYPE[type]);
};
